import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import Logo from "@/components/Logo";

export default function TeamLogin() {
  const { user, loginInternal } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  React.useEffect(() => {
    if (user?.role === "admin" || user?.role === "team_member") navigate("/admin", { replace: true });
    if (user?.role === "client") navigate("/portal", { replace: true });
  }, [user, navigate]);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const u = await loginInternal(email, password);
      navigate(u.role === "admin" || u.role === "team_member" ? "/admin" : "/", { replace: true });
    } catch (err) {
      setError(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-soft px-6 py-16" data-testid="team-login-page">
      <div className="blob bg-navy/30 w-96 h-96 -top-20 -right-20 rounded-full" />
      <div className="relative w-full max-w-md card p-10">
        <div className="flex justify-center mb-2">
          <Logo surface="light" to={null} testid="team-login-logo" size="h-14" />
        </div>
        <div className="w-12 h-12 rounded-full bg-gold text-white flex items-center justify-center mx-auto my-5">
          <Lock className="w-5 h-5" />
        </div>
        <div className="eyebrow text-center">Staff Sign-in</div>
        <h1 className="mt-3 text-4xl text-center">Team &amp; Admin.</h1>
        <p className="mt-3 text-navy/65 text-sm text-center">
          Use your ConnectHer staff email and password.
        </p>
        <form onSubmit={handleSubmit} data-testid="team-login-form" className="mt-8 space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest text-navy/60">Email</label>
            <input
              data-testid="team-login-email"
              type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-field mt-2"
              placeholder="you@thechhq.com"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-navy/60">Password</label>
            <input
              data-testid="team-login-password"
              type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-field mt-2"
              placeholder="••••••••"
            />
          </div>
          {error && <p data-testid="team-login-error" className="text-sm text-red-500">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="team-login-submit"
            className="btn-primary w-full justify-center"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign In"}
          </button>
        </form>
        <p className="mt-6 text-xs text-navy/45 text-center">
          Client?{" "}
          <a href="/login" data-testid="client-login-link" className="text-gold underline">
            Continue with Google here
          </a>
        </p>
      </div>
    </div>
  );
}
